import { helper } from '@ember/component/helper';

export default helper(function inc([value]: [unknown]) {
  const number = Number(value);
  return isNaN(number) ? 0 : number + 1;
});
